import React, { useState } from 'react'
import { INFTCollectionItems } from '../../../models/INFTCollectionItems'
import { NFTCard } from '../../../components/NFTCard'
import { ApprovalState } from '../../../../../hooks/useApproveCallback'
import { useStakeNFT } from '../../../../../hooks/useNFTStake'
import { INFTStakeList, StakeState } from '../../../models/INFTStake'
import { NFTStakeList } from '../../../data/NFTStakeList'

interface IStakeCardProps {
  data: INFTCollectionItems
  account: string
  approve?: Function
  approveState?: ApprovalState
  stakingData?: INFTStakeList
}

export default function StakeCard({ data, account, approveState, approve, stakingData }: IStakeCardProps) {
  const foundContractAddress = stakingData?.contractAddress ?? NFTStakeList[0].contractAddress

  const [stakeState, SetStakeState] = useState(StakeState.UNSTAKED)

  const [stakeNFT] = useStakeNFT(+data.tokenID, foundContractAddress)

  const stakeToggle = () => {
    if (approveState === ApprovalState.APPROVED) {
      SetStakeState(StakeState.STAKE_PENDING)
      stakeNFT()
        .then(() => {
          SetStakeState(StakeState.STAKED)
        })
        .catch(() => SetStakeState(StakeState.UNSTAKED))
    }
  }

  return (
    <>
      <NFTCard
        tokenId={+data.tokenID}
        tokenContractAddress={data.contract.id}
        //account={account}
        owner={account}
        priceInfo={null}
        saleToken={''}
        stakeToggle={stakeToggle}
        stakeState={stakeState}
        approveState={approveState}
        approve={approve}
        isStake={false}
      />
    </>
  )
}
